package kz.dentalcrm.app.core.ui.components

import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import kz.dentalcrm.app.theme.DefaultTheme


@Composable
fun InfiniteProgress(
    modifier: Modifier,
    strokeWidth: Dp = 12.dp,
    progressColor: Color = DefaultTheme.colors.primary,
) {

    CircularProgressIndicator(
        modifier = modifier,
        color = progressColor,
        strokeWidth = strokeWidth
    )
}